import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import EntityStore from 'stores/EntityStore';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

import {AvailabilityToShow, AllowedVersions} from './constants';

interface Props {
  updateDropdown: (version: string, availabilityToShow: AvailabilityToShow) => void;
  dropdownLabel: string;
}

export default function SwaggerDropdown(props: Props): JSX.Element {
  const {updateDropdown, dropdownLabel} = props;
  const isSignedIn = EntityStore.currentUser() != null;

  function getVersionSingleItemButton(version: string): JSX.Element {
    return (
      <Option
        onSelect={() => {
          updateDropdown(version, AvailabilityToShow.GA);
        }}
      >
        {version}
      </Option>
    );
  }

  function getVersionSubmenu(version: string): JSX.Element {
    if (
      BenchlingConfig.CAPILLARY_ENABLE_PRE_RELEASE_DOCS_UI ||
      BenchlingConfig.CAPILLARY_ENABLE_NOT_AVAILABLE_DOCS_UI
    ) {
      return (
        <Option value={version}>
          {version}
          <Menu>
            <Option
              onSelect={() => {
                updateDropdown(version, AvailabilityToShow.GA);
              }}
            >
              {version} (GA)
            </Option>
            {BenchlingConfig.CAPILLARY_ENABLE_PRE_RELEASE_DOCS_UI && (
              <Option
                onSelect={() => {
                  updateDropdown(version, AvailabilityToShow.LA);
                }}
              >
                {version} (Pre-release)
              </Option>
            )}
            {BenchlingConfig.CAPILLARY_ENABLE_NOT_AVAILABLE_DOCS_UI && (
              <Option
                onSelect={() => {
                  updateDropdown(version, AvailabilityToShow.NOT_AVAILABLE);
                }}
              >
                {version} (Not available)
              </Option>
            )}
          </Menu>
        </Option>
      );
    } else {
      return getVersionSingleItemButton(version);
    }
  }

  function shouldDisplayV3Button(versionConfig: boolean): boolean {
    if (BenchlingConfig.CAPILLARY_ENABLE_LOGGED_OUT_OPENAPI_SPEC || versionConfig) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div>
      <Dropdown
        menu={
          <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM}>
            {isSignedIn &&
              BenchlingConfig.CAPILLARY_ENABLE_V3_DRAFT_API &&
              getVersionSingleItemButton(AllowedVersions.V3_DRAFT)}
            {shouldDisplayV3Button(BenchlingConfig.CAPILLARY_ENABLE_V3_ALPHA_API) &&
              getVersionSingleItemButton(AllowedVersions.V3_ALPHA)}
            {shouldDisplayV3Button(BenchlingConfig.CAPILLARY_ENABLE_V3_BETA_API) &&
              getVersionSingleItemButton(AllowedVersions.V3_BETA)}
            {getVersionSubmenu(AllowedVersions.V2)}
            {getVersionSubmenu(AllowedVersions.V2_BETA)}
            {getVersionSubmenu(AllowedVersions.V2_ALPHA)}
          </Menu>
        }
      >
        <Button
          size={ButtonSize.SMALL}
          buttonStyle={ButtonStyle.SECONDARY}
          text={dropdownLabel}
          isDropdown={true}
        />
      </Dropdown>
    </div>
  );
}
